import {
  generateSectionParagraphs,
  getSectionHeader,
} from "../utils/WordExportUtils";
import { defaultFontBold, defaultFontNormal } from "../utils/styling";

const getNonConsentingCompanyStatus = (poaData, value) => {
  return [
    ...new Set(
      poaData.adjusted_caps
        .filter((cap) => cap.non_consenting_company === value)
        .map((cap) => cap.company_name),
    ),
  ];
};

export const getAppendix1Paragraphs = (data) => {
  const { poaData } = data;
  const consentingCompanies = getNonConsentingCompanyStatus(poaData, false);
  const nonConsentingCompanies = getNonConsentingCompanyStatus(poaData, true);

  const consentingCompaniesExist = consentingCompanies.length > 0;
  const nonConsentingCompaniesExist = nonConsentingCompanies.length > 0;

  const paragraphs = [
    {
      condition: consentingCompaniesExist,
      segments: [
        {
          text: "List of consenting companies:",
          font: defaultFontBold,
          break: 1,
        },
      ],
    },
    ...(consentingCompaniesExist
      ? consentingCompanies.map((company) => ({
          condition: true,
          bullet: "dot",
          segments: [
            {
              text: company,
              font: defaultFontNormal,
            },
          ],
        }))
      : []),
    {
      condition: nonConsentingCompaniesExist,
      segments: [
        {
          text: "List of non-consenting companies:",
          font: defaultFontBold,
          break: 1,
        },
      ],
    },
    ...(nonConsentingCompaniesExist
      ? nonConsentingCompanies.map((company) => ({
          condition: true,
          bullet: "dot",
          segments: [
            {
              text: company,
              font: defaultFontNormal,
            },
          ],
        }))
      : []),
  ];

  return [
    getSectionHeader("Appendix 1"),
    ...generateSectionParagraphs(paragraphs),
  ];
};
